export default class Wechat {
    constructor () {
        // Wechat account removal

        const wechatButton = document.querySelector('.js-wechat');
        if (wechatButton) {
            wechatButton.addEventListener('click', event => {
                event.preventDefault();
                this.deleteLink = event.target.href;
                fetch(event.target.href, {
                    headers: {
                        credentials: "include"
                    },
                }).then(response => {
                    switch (response.status) {
                        case 200:
                            window.location = window.location.href;
                            break;
                        case 502: // WeChat error
                            return response.json();
                        case 500: // Guzzle error
                            return response.json();
                    }
                }).then(errorMessage => {
                    const input = document.querySelector('#agent_edit_weChatAccount');
                    const error = document.createElement('ul');
                    error.classList.value = "c-main fs-0c8 fs-i pt-0c5";
                    error.appendChild(document.createElement('li')).innerText = errorMessage.toString();

                    input.parentElement.appendChild(error);
                }).catch(console.log); // network error, fetch failed
            });
        }
    }
}